import { useQuery } from '@grandvisionhq/graphql';
import { GET_ESTIMATED_DELIVERY_BY_SKUS } from '../operations/queries/get-estimated-delivery-by-skus.js';

const useGetDispatchDate = (items, shippingMethodKey)=>{
    var ref;
    const { data , loading , error  } = useQuery(GET_ESTIMATED_DELIVERY_BY_SKUS, {
        variables: {
            input: {
                skuQuantityPairs: items,
                shippingMethodKey
            }
        },
        skip: !items || !Array.isArray(items) || !items.length
    });
    // Dates are returned as any by GraphQL, so we need to cast them
    const dispatchDate = data === null || data === void 0 ? void 0 : (ref = data.estimatedDeliveryBySkus) === null || ref === void 0 ? void 0 : ref.shippingDate;
    if (error) {
        console.error(error);
    }
    return {
        dispatchDate,
        loading,
        error
    };
};

export { useGetDispatchDate };
//# sourceMappingURL=use-get-dispatch-date.js.map
